/**
 * Traduções centralizadas para características e tipos de imóveis
 */

export const FEATURE_TRANSLATIONS: { [key: string]: string } = {
  // Características básicas
  'AIR_CONDITIONING': 'Ar condicionado',
  'POOL': 'Piscina',
  'PRIVATE_POOL': 'Piscina privativa',
  'SWIMMING_POOL': 'Piscina',
  'GYM': 'Academia',
  'FITNESS_CENTER': 'Centro de fitness',
  'GARDEN': 'Jardim',
  'GREEN_AREA': 'Área verde',
  'GARAGE': 'Garagem',
  'PARKING': 'Estacionamento',
  'ELEVATOR': 'Elevador',
  'BALCONY': 'Varanda',
  'TERRACE': 'Terraço',
  'FURNISHED': 'Mobiliado',
  'PET_FRIENDLY': 'Aceita pets',
  'PETS_ALLOWED': 'Aceita animais',
  'SECURITY': 'Segurança 24h',
  'CONCIERGE': 'Portaria',
  'CONCIERGE_24H': 'Portaria 24h',
  
  // Áreas de lazer e sociais
  'PLAYGROUND': 'Playground',
  'KIDS_AREA': 'Área infantil',
  'PARTY_ROOM': 'Salão de festas',
  'PARTY_HALL': 'Salão de festas',
  'BARBECUE': 'Churrasqueira',
  'BARBECUE_AREA': 'Área de churrasqueira',
  'BARBECUE_GRILL': 'Churrasqueira',
  'BARBECUE_BALCONY': 'Varanda gourmet',
  'GOURMET_AREA': 'Área gourmet',
  'GOURMET_SPACE': 'Espaço gourmet',
  'GOURMET_BALCONY': 'Varanda gourmet',
  'GAMES_ROOM': 'Sala de jogos',
  'COWORKING': 'Coworking',
  
  // Esportes e wellness
  'TENNIS_COURT': 'Quadra de tênis',
  'SOCCER_FIELD': 'Campo de futebol',
  'SPORTS_COURT': 'Quadra esportiva',
  'SQUASH': 'Quadra de squash',
  'SAUNA': 'Sauna',
  'SAUNA_STEAM': 'Sauna a vapor',
  'JACUZZI': 'Jacuzzi',
  'BATHTUB': 'Banheira',
  'SOLARIUM': 'Solário',
  'BICYCLES_PLACE': 'Bicicletário',
  
  // Utilitários e serviços
  'LAUNDRY': 'Lavanderia',
  'SERVICE_AREA': 'Área de serviço',
  'MAID_ROOM': 'Quarto de empregada',
  'STORAGE': 'Depósito',
  'OFFICE_SPACE': 'Escritório',
  'HOME_OFFICE': 'Home office',
  'ELECTRONIC_GATE': 'Portão eletrônico',
  
  // Cozinha e áreas internas
  'AMERICAN_KITCHEN': 'Cozinha americana',
  'LARGE_KITCHEN': 'Cozinha ampla',
  'KITCHEN_CABINETS': 'Armários de cozinha',
  'PANTRY': 'Despensa',
  'DINNER_ROOM': 'Sala de jantar',
  'LARGE_ROOM': 'Sala ampla',
  'INTEGRATED_ENVIRONMENTS': 'Ambientes integrados',
  
  // Quartos e armários
  'CLOSET': 'Closet',
  'BUILTIN_WARDROBE': 'Armário embutido',
  'BEDROOM_WARDROBE': 'Guarda-roupa do quarto',
  'PLANNED_FURNITURE': 'Móveis planejados',
  'BATHROOM_CABINETS': 'Armários do banheiro',
  
  // Banheiros
  'LAVABO': 'Lavabo',
  'BLINDEX_BOX': 'Box blindex',
  
  // Infraestrutura
  'ELECTRICITY': 'Energia elétrica',
  'SEWAGE': 'Esgoto',
  'PAVED_STREET': 'Rua pavimentada',
  'NATURAL_VENTILATION': 'Ventilação natural',
  'COLD_FLOOR': 'Piso frio',
  'FULL_FLOOR': 'Andar inteiro',
  
  // Tecnologia e conforto
  'INTERNET': 'Internet',
  'CABLE_TV': 'TV a cabo',
  'HOME_THEATER': 'Home theater',
  'FIREPLACE': 'Lareira',
  'WINE_CELLAR': 'Adega',
  
  // Características especiais
  'GATED_COMMUNITY': 'Condomínio fechado',
  'PENTHOUSE': 'Cobertura',
  'DUPLEX': 'Duplex',
  'TRIPLEX': 'Triplex',
  'LOFT': 'Loft',
  'STUDIO': 'Studio',
  'PANORAMIC_VIEW': 'Vista panorâmica',
  'DISABLED_ACCESS': 'Acesso para deficientes',
  'SAFETY_CIRCUIT': 'Circuito de segurança',
  'PLAN': 'Planta',
  
  // Características adicionais comuns no Brasil
  'SUITE_MASTER': 'Suíte master',
  'HYDROMASSAGE': 'Hidromassagem',
  'SEA_VIEW': 'Vista para o mar',
  'LAMINATE_FLOOR': 'Piso laminado',
  'BUILT_IN_WARDROBES': 'Armários planejados',
  'COVERED_GARAGE': 'Garagem coberta',
  'PORTER_24H': 'Portaria 24h'
};

export const PROPERTY_TYPE_TRANSLATIONS: { [key: string]: string } = {
  // Tipos em inglês (vindos da API externa)
  'APARTMENT': 'Apartamento',
  'HOUSE': 'Casa',
  'CONDO': 'Casa em condomínio',
  'PENTHOUSE': 'Cobertura',
  'STUDIO': 'Studio',
  'LOFT': 'Loft',
  'DUPLEX': 'Duplex',
  'TRIPLEX': 'Triplex',
  'HOME': 'Casa',
  'FARM': 'Chácara',
  'LAND': 'Terreno',
  'COMMERCIAL': 'Comercial',
  'OFFICE': 'Escritório',
  'STORE': 'Loja',
  'WAREHOUSE': 'Galpão',
  'INDUSTRIAL': 'Industrial',
  
  // Tipos em português (do banco de dados)
  'apartamento': 'Apartamento',
  'casa': 'Casa',
  'sobrado': 'Sobrado',
  'terreno': 'Terreno',
  'comercial': 'Comercial',
  'chacara': 'Chácara',
  'sitio': 'Sítio',
  'cobertura': 'Cobertura',
  'loft': 'Loft',
  'studio': 'Studio',
  'kitnet': 'Kitnet',
  'flat': 'Flat',
  'duplex': 'Duplex',
  'triplex': 'Triplex'
};

export const TRANSACTION_TYPE_TRANSLATIONS: { [key: string]: string } = {
  'SALE': 'Venda',
  'RENT': 'Aluguel',
  'LEASE': 'Locação'
};

/**
 * Traduz uma característica do inglês para português
 * @param feature Característica em inglês
 * @returns Característica traduzida ou o valor original se não encontrada
 */
export const translateFeature = (feature: string): string => {
  if (!feature) return '';
  
  const upperFeature = feature.toUpperCase().trim();
  const translation = FEATURE_TRANSLATIONS[upperFeature];
  
  if (translation) {
    return translation;
  }
  
  // Se não encontrou tradução, retorna formatado (primeira letra maiúscula, substitui _ por espaço)
  return feature
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, l => l.toUpperCase());
};

/**
 * Traduz um tipo de propriedade do inglês para português
 * @param type Tipo em inglês
 * @returns Tipo traduzido ou o valor original se não encontrada
 */
export const translatePropertyType = (type: string): string => {
  if (!type) return '';
  
  const upperType = type.toUpperCase().trim();
  const translation = PROPERTY_TYPE_TRANSLATIONS[upperType];
  
  if (translation) {
    return translation;
  }
  
  // Se não encontrou tradução, retorna formatado
  return type
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, l => l.toUpperCase());
};

/**
 * Traduz um tipo de transação do inglês para português
 * @param type Tipo de transação em inglês
 * @returns Tipo traduzido ou o valor original se não encontrada
 */
export const translateTransactionType = (type: string): string => {
  if (!type) return '';
  
  const upperType = type.toUpperCase().trim();
  const translation = TRANSACTION_TYPE_TRANSLATIONS[upperType];
  
  if (translation) {
    return translation;
  }
  
  // Se não encontrou tradução, retorna formatado
  return type
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, l => l.toUpperCase());
};